/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/1/18
 * Copyright All Rights Reserved
 */

import { API_HOST, API_PROTOCOL } from 'support/config';

const apiBaseUrl = config => `${config(API_PROTOCOL)}://${config(API_HOST)}`;

export default apiBaseUrl;
